import { render, staticRenderFns } from "./CreateModalComponent.vue?vue&type=template&id=2fb2b97f"
import script from "./CreateModalComponent.vue?vue&type=script&lang=js"
export * from "./CreateModalComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports